module.exports = __webpack_public_path__ + "components/Map/graphics/tree-cluster-pin-small.4cd4ed08b22461e2fd7a87c6a2a056d3.png";